import type { PoleasImportPreviewRow } from '@/dtos/PoleasImport'
import { TableData, TableRow } from '@/components/Grid'
import { Text } from '@chakra-ui/react'

export const ImportPreviewRow = ({ item }: { item: PoleasImportPreviewRow }) => {

  return (
    <TableRow >
      <TableData verticalAlign={'middle'}>
        <Text >
          {item.leasingContractNumber}
        </Text>
      </TableData>

      <TableData verticalAlign={'middle'} >
        <Text>{item.vin}</Text>
      </TableData>

      <TableData verticalAlign={'middle'} >
        <Text>{item.vehicleInfo}</Text>
      </TableData>

      <TableData verticalAlign={'middle'} >
        <Text>{item.policyHolderInfo}</Text>
      </TableData>

      <TableData verticalAlign={'middle'} >
        <Text>{item.error}</Text>
      </TableData>

    </TableRow>
  )
}